import { GoToRegistrationStepPayload, RegistrationActionTypes } from 'store/registration/actions/types'

export const GO_TO_REGISTRATION_STEP = 'REGISTRATION/GO_TO'
export const NEXT_REGISTRATION_STEP = 'REGISTRATION/NEXT_STEP'
export const PREVIOUS_REGISTRATION_STEP = 'REGISTRATION/PREVIOUS_STEP'

export const goToRegistrationStep = ({ step }: GoToRegistrationStepPayload): RegistrationActionTypes => {
  return { type: GO_TO_REGISTRATION_STEP, step }
}

export const nextRegistrationStep = (): RegistrationActionTypes => {
  return { type: NEXT_REGISTRATION_STEP }
}

export const previousRegistrationStep = (): RegistrationActionTypes => {
  return { type: PREVIOUS_REGISTRATION_STEP }
}
